<template>
  <QueryView
    ref="queryView"
    :table-config="tableConfig"
    :town-selection="false"
    :region-selection="true"
    :province-selection="true"
    use-expansion
  >
    <template #field__blueFlag="{ data }">
      <div
        v-if="data?.blueFlag != null"
        class="query-beaches-view__checkbox"
      >
        <Checkbox
          :model-value="data.blueFlag"
          binary
          readonly
          :true-value="true"
          :false-value="false"
        />
      </div>
    </template>
    <template #field__hasDisabledAccess="{ data }">
      <span>{{ data.hasDisabledAccess }}</span>
    </template>
    <template #expansion="{ data }">
      <div
        class="query__expansion-container"
      >
        <QueryExpansionField
          field-name="Descripción"
          :field-value="data.description"
        />
        <QueryExpansionField
          field-name="Aseos"
          :field-value="data.hasWC"
        />
        <QueryExpansionField
          field-name="Duchas"
          :field-value="data.hasShowers"
        />
        <QueryExpansionField
          field-name="Comida"
          :field-value="data.hasFood"
        />
        <QueryExpansionField
          field-name="Bebida"
          :field-value="data.hasDrinks"
        />
      </div>
    </template>
  </QueryView>
</template>
<script setup>
import {ref} from 'vue';
import {useClipboard} from '@vueuse/core';
import Checkbox from 'primevue/checkbox';
import QueryView from '../QueryView';
import QueryExpansionField from '@/components/query-expansion-field/QueryExpansionField';
import QueryTableConfig from '../query-table.view-config.js';
import {BEACHES_SCHEMA} from './query-beaches-table.view-config';
import {searchBeach} from '@/api/beach/beach.api';
import {
  searchBeachHtml,
  searchBeachPdf,
  getBeachPdf,
} from '@/api/beach/beach.api.pdf.js';
// #region Props, Emits

// #endregion

// #region Params, Ref, Reactives, Computed
const queryView = ref();
const {copy} = useClipboard();
// #endregion

// #region Functions

async function goBeach({coordinates, name, visible}) {
  const goCoordinates = queryView?.value?.goCoordinates;
  const zoom = 10;
  if (!!goCoordinates) {
    goCoordinates({coordinates, name, visible, zoom});
  }
}
function beachToText({
  name,
  description,
  province,
  town,
  blueFlag,
  hasWC,
  hasShowers,
  hasFood,
  hasDrinks,
  hasDisabledAccess,
}) {
  const res = `
      Nombre: ${name}
      Provincia: ${province}
      Municipio: ${town}
      Desripción: ${description}
      Bandera azul: ${blueFlag}
      Aseos: ${hasWC}
      Duchas: ${hasShowers}
      Comida: ${hasFood}
      Bebida: ${hasDrinks}
      Acceso para personas con discapacidad: ${hasDisabledAccess}
      `;
  return res;
}
async function printBeach(data) {
  const printRecord = queryView?.value?.printRecord ?? null;
  if (!!printRecord) {
    await printRecord(data.id, 'Playa - ' + data.name, getBeachPdf);
  }
}
async function htmlBeachQuery() {
  const printQuery = queryView?.value?.printQuery ?? null;
  if (!!printQuery) {
    await printQuery('Informe Playas', searchBeachHtml, 'html');
  }
}
async function printBeachQuery() {
  const printQuery = queryView?.value?.printQuery ?? null;
  if (!!printQuery) {
    await printQuery('Informe Playas', searchBeachPdf);
  }
}
// #endregion
// functions previously defined
const tableConfig = new QueryTableConfig({
  title: '',
  api: searchBeach,
  recordToText: beachToText,
  copyClipboard: copy,
  htmlQuery: htmlBeachQuery,
  printQuery: printBeachQuery,
  printRecord: printBeach,
  centerMap: goBeach,
  schema: BEACHES_SCHEMA,
});

// #region Effects, Hooks

// #endregion

// #region Provide, Expose

// #endregion
</script>

<style lang="scss" scoped>
.query-beaches-view__checkbox {
  text-align: center;
}
</style>
